module.exports = __webpack_public_path__ + "img/drupal8.1a66aed3.png";